import React from "react";

function EditBannerScreen() {
  return <div></div>;
}

export default EditBannerScreen;
